if(!String.prototype.replaceAll){
    String.prototype.replaceAll = function(key, result){
        return this.replace(new RegExp(key,'g'),result);
    }
}